// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$("section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	let lastScrollTop = 0;

	//add header class
	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		// Add "scrolled" class when not at the top
		if (scrollTop > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}

		// Determine scroll direction
		if (scrollTop > lastScrollTop) {
			// Scrolling Down
			$("#masthead").removeClass("scrolling-up").addClass("scrolling-down");
		} else if (scrollTop < lastScrollTop) {
			// Scrolling Up
			$("#masthead").removeClass("scrolling-down").addClass("scrolling-up");
		}

		// Remove scrolling direction classes if at the very top
		if (scrollTop === 0) {
			$("#masthead").removeClass("scrolling-up scrolling-down");
		}

		lastScrollTop = scrollTop;
	});

	// On page load, check scroll position
	if ($(window).scrollTop() > 1) {
		$("#masthead").addClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		var isOpen = $("body").toggleClass("mobile-navigation--open").hasClass("mobile-navigation--open");

		$(this).toggleClass("active").attr("aria-expanded", isOpen ? "true" : "false").attr("aria-label", isOpen ? "Close menu" : "Open menu");
		// `inert` (not aria-hidden) while closed: the panel is off-canvas rather than
		// display:none, so without it its links would stay focusable while invisible.
		$(".mobile-navigation").toggleClass("active").prop("inert", !isOpen);
	});

	$("#mobile-navigation .menu-item-has-children").each(function () {
		var $li = $(this),
			$submenu = $li.children("ul.sub-menu"),
			submenuId = ($li.attr("id") || "menu-item") + "-submenu";

		$submenu.attr("id", submenuId);

		$li.append(
			$('<button type="button" class="menu-expand" aria-expanded="false"></button>')
				.attr("aria-controls", submenuId)
				.attr("aria-label", "Expand submenu")
				.append('<i class="fa-sharp fa-solid fa-chevron-down" aria-hidden="true"></i>')
		);
	});

	$("#mobile-navigation").on("click", ".menu-expand", function () {
		var $btn = $(this),
			isExpanded = $btn.toggleClass("active").hasClass("active");

		$btn.attr("aria-expanded", isExpanded ? "true" : "false");
		$btn.parent("li").toggleClass("active", isExpanded).toggleClass("sub-menu-open", isExpanded);
		$btn.parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
DESKTOP FLYOUT ARIA-EXPANDED SYNC

The flyout itself opens/closes purely via the :hover / :focus-within rules
in input.css; this just keeps aria-expanded on the top-level link truthful
for screen readers as the mouse or keyboard focus enters/leaves it.
================================
*/

	$(".main-menu > ul > li.menu-item-has-children")
		.on("mouseenter focusin", function () {
			$(this).children("a").attr("aria-expanded", "true");
		})
		.on("mouseleave", function () {
			$(this).children("a").attr("aria-expanded", "false");
		})
		.on("focusout", function (e) {
			if (!this.contains(e.relatedTarget)) {
				$(this).children("a").attr("aria-expanded", "false");
			}
		});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}


	/*
=================================
FANCYBOX
=================================
*/


	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});


	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	/*if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}*/

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-fancybox]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
===========================
MATCH HEIGHTS
===========================
*/

	$(function () {
		$(".news-block h3.block-title").matchHeight({property: "height"});
	});


	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
==========================
AJAX
==========================
*/

// LOAD MORE POSTS
$(".archive-posts").on("click", ".load-more", function (e) {
    e.preventDefault();

    var button = $(this);
    var currentPage = parseInt(rooster_loadmore_params.current_page, 10);
    var maxPage = parseInt(rooster_loadmore_params.max_page, 10);

    $.ajax({
        url: rooster_loadmore_params.ajaxurl,
        type: "POST",
        data: {
            action: "loadmore",
            query: rooster_loadmore_params.posts,
            page: currentPage
        },
        beforeSend: function () {
            button.text("Loading...");
        },
        success: function (data) {
            if (data) {
                $(".archive-posts .posts-container").append(data);

                rooster_loadmore_params.current_page = currentPage + 1;

                $(".archive-posts input.post-count").val(
                    $(".archive-posts .posts-container article").length
                );

                if (rooster_loadmore_params.current_page >= maxPage) {
                    button.closest(".load-more-posts").remove();
                } else {
                    button.text("Load More");
                }
            } else {
                button.closest(".load-more-posts").remove();
            }
        }
    });
});
}); //end document.ready


if(document.querySelector('.block-item')){
	const columns = document.querySelectorAll('.block-item');
	columns.forEach(column => {
		const columnClassList = column.classList;
		const button = column.querySelector('a.button');
		if(!button){
			return;
		}
		const href = button.getAttribute('href');
		if(!href){
			return;
		}
		const text = button.textContent;
		
		button.outerHTML = `<div class="block-item-button-wrap"><span class="button third">${text}</span></div>`;
		column.outerHTML = `<a class="${columnClassList} mb-0" href="${href}">${column.innerHTML}</a>`;
	});
}

if(document.querySelector('.call-to-action')){
	const cta = document.querySelectorAll('.call-to-action');
	cta.forEach(cta => {
		const buttons = cta.querySelectorAll('.button');
		buttons.forEach(button => {
			button.classList.remove('primary', 'secondary');
			button.classList.add('forth');
		});

	});
}



if(document.querySelectorAll('.card-item p').length > 0){
document.querySelectorAll('.card-item p').forEach(p => {
    const strong = p.querySelector('strong');

    if (!strong) return;

    const text = strong.textContent.trim().toLowerCase();

    if (text.includes('email') || text.includes('call')) {
        p.style.marginBottom = '0';
    }
});
}

function handleContactBlocks(){
	if(document.querySelector('.form-block') && document.querySelector('.three-column-cards')){
    
	const formBlock = document.querySelector('.form-block');
	const threeColumnCards = document.querySelector('.three-column-cards');

	//make this only happen at max 660px
	if(window.innerWidth <= 660){
		//if formBlock is sibling to threeColumnCards
		if(formBlock.nextElementSibling === threeColumnCards){
			console.log('formBlock is sibling to threeColumnCards');
			formBlock.style.paddingBottom = '0';
			threeColumnCards.style.marginTop = '0';
		}
	}
	//if screen width is greater than 660px
	if(window.innerWidth > 660){
		//if formBlock is sibling to threeColumnCards
		if(formBlock.nextElementSibling === threeColumnCards){
			console.log('formBlock is sibling to threeColumnCards');
			//remove the actual styling
			formBlock.removeAttribute('style');
			threeColumnCards.removeAttribute('style');
		}
	}

}
};

//watch resize
window.addEventListener('resize', () => {
	handleContactBlocks();
});

//run on load
handleContactBlocks();


document.addEventListener('DOMContentLoaded', function () {
	initTwoPageLinkBlockSwipers();
	initThreePageLinkBlockSwipers();
	initFeaturedPostsSwipers();
	initThreeColumnImagesSwipers();
	initSmallLinkBlockSwipers();
	initLargeSliderSwipers();
	initFeaturedLocationsSwipers();
	alignMegaMenuColumns();
	initTreatmentServicesSwipers();
});

/*
=====================
TWO PAGE LINK BLOCKS
=====================
*/

function initTwoPageLinkBlockSwipers() {
	const swipers = document.querySelectorAll('.js-two-page-link-blocks-swiper');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		const section = swiperEl.closest('.two-page-link-blocks-and-content');

		if (!section) {
			return;
		}

		let swiperInstance = null;

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 1.15,
				spaceBetween: 8,
				speed: 450,
				watchOverflow: true,
				grabCursor: true,

				navigation: {
					nextEl: section.querySelector('.two-page-link-blocks-and-content__arrow--next'),
					prevEl: section.querySelector('.two-page-link-blocks-and-content__arrow--prev'),
				},

				pagination: {
					el: section.querySelector('.two-page-link-blocks-and-content__pagination'),
					clickable: true,
				},
			});
		}

		function disableSwiper() {
			if (!swiperInstance) {
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}

		function handleBreakpoint() {
			if (window.matchMedia('(max-width: 767px)').matches) {
				enableSwiper();
			} else {
				disableSwiper();
			}
		}

		handleBreakpoint();

		window.addEventListener('resize', handleBreakpoint);
	});
}

/*
=====================
THREE PAGE LINK BLOCKS
=====================
*/

function initThreePageLinkBlockSwipers() {
	const swipers = document.querySelectorAll('.js-three-page-link-blocks-swiper');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		const section = swiperEl.closest('.three-page-link-blocks-and-content');

		if (!section) {
			return;
		}

		let swiperInstance = null;
		const breakpoint = window.matchMedia('(max-width: 767px)');

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 'auto',
				spaceBetween: 20,
				speed: 500,
				watchOverflow: true,
				grabCursor: true,

				navigation: {
					nextEl: section.querySelector('.three-page-link-blocks-and-content__arrow--next'),
					prevEl: section.querySelector('.three-page-link-blocks-and-content__arrow--prev'),
				},

				pagination: {
					el: section.querySelector('.three-page-link-blocks-and-content__pagination'),
					clickable: true,
				},
			});
		}

		function disableSwiper() {
			if (!swiperInstance) {
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}

		function handleBreakpoint() {
			if (breakpoint.matches) {
				enableSwiper();
			} else {
				disableSwiper();
			}
		}

		handleBreakpoint();

		if (breakpoint.addEventListener) {
			breakpoint.addEventListener('change', handleBreakpoint);
		} else {
			breakpoint.addListener(handleBreakpoint);
		}
	});
}

/*
=====================
FEATURED POSTS
=====================
*/

function initFeaturedPostsSwipers() {
	const swipers = document.querySelectorAll('[data-featured-posts-swiper]');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		let swiperInstance = null;
		const breakpoint = window.matchMedia('(max-width: 1023px)');

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				spaceBetween: 20,
				speed: 500,
				watchOverflow: true,
				grabCursor: true,

				pagination: {
					el: swiperEl.querySelector('.featured-posts-swiper__pagination'),
					clickable: true,
				},

				navigation: {
					nextEl: swiperEl.querySelector('.featured-posts-swiper__arrow--next'),
					prevEl: swiperEl.querySelector('.featured-posts-swiper__arrow--prev'),
				},
			});

			swiperEl.featuredPostsSwiper = swiperInstance;
		}

		function disableSwiper() {
			if (!swiperInstance) {
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;
			swiperEl.featuredPostsSwiper = null;
		}

		function handleBreakpoint() {
			if (breakpoint.matches) {
				enableSwiper();
			} else {
				disableSwiper();
			}
		}

		handleBreakpoint();

		if (breakpoint.addEventListener) {
			breakpoint.addEventListener('change', handleBreakpoint);
		} else {
			breakpoint.addListener(handleBreakpoint);
		}
	});
}

/*
=====================
THREE COLUMN IMAGES
=====================
*/

function initThreeColumnImagesSwipers() {
	const swipers = document.querySelectorAll('[data-three-column-images-swiper]');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		let swiperInstance = null;
		const breakpoint = window.matchMedia('(max-width: 1023px)');

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				spaceBetween: 20,
				speed: 500,
				watchOverflow: true,
				grabCursor: true,

				pagination: {
					el: swiperEl.querySelector('.three-column-images-swiper__pagination'),
					clickable: true,
				},

				navigation: {
					nextEl: swiperEl.querySelector('.three-column-images-swiper__arrow--next'),
					prevEl: swiperEl.querySelector('.three-column-images-swiper__arrow--prev'),
				},
			});

			swiperEl.threeColumnImagesSwiper = swiperInstance;
		}

		function disableSwiper() {
			if (!swiperInstance) {
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;
			swiperEl.threeColumnImagesSwiper = null;
		}

		function handleBreakpoint() {
			if (breakpoint.matches) {
				enableSwiper();
			} else {
				disableSwiper();
			}
		}

		handleBreakpoint();

		if (breakpoint.addEventListener) {
			breakpoint.addEventListener('change', handleBreakpoint);
		} else {
			breakpoint.addListener(handleBreakpoint);
		}
	});
}

/*
=====================
SMALL LINK BLOCKS
=====================
*/

function initSmallLinkBlockSwipers() {
	const sections = document.querySelectorAll('.small-link-blocks');

	if (!sections.length || typeof Swiper === 'undefined') {
		return;
	}

	sections.forEach(function (section) {
		const swiperEl = section.querySelector('.small-link-blocks__swiper');
		const slides = section.querySelectorAll('.small-link-blocks__slide');
		const container = section.querySelector('.small-link-blocks__container');

		if (!swiperEl || !slides.length || !container) {
			return;
		}

		let swiperInstance = null;
		let resizeTimer = null;

		function shouldUseSwiper() {
			/*
				Grid from 1353px upwards.
				Swiper from 1352px and below, but only when cards no longer fit.
			*/
			if (window.innerWidth >= 1353) {
				return false;
			}

			const cardMinWidth = 239;
			const gap = 20;
			const totalRequiredWidth = slides.length * cardMinWidth + Math.max(slides.length - 1, 0) * gap;
			const availableWidth = container.getBoundingClientRect().width;

			return totalRequiredWidth > availableWidth;
		}

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			section.classList.add('is-swiper-active');

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 'auto',
				spaceBetween: 20,
				speed: 450,
				grabCursor: true,
				watchOverflow: true,

				navigation: {
					nextEl: section.querySelector('.small-link-blocks__arrow--next'),
					prevEl: section.querySelector('.small-link-blocks__arrow--prev'),
				},

				pagination: {
					el: section.querySelector('.small-link-blocks__pagination'),
					clickable: true,
				},
			});
		}

		function disableSwiper() {
			if (!swiperInstance) {
				section.classList.remove('is-swiper-active');
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;

			section.classList.remove('is-swiper-active');
		}

		function updateLayout() {
			if (shouldUseSwiper()) {
				enableSwiper();

				if (swiperInstance) {
					swiperInstance.update();
				}
			} else {
				disableSwiper();
			}
		}

		updateLayout();

		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);

			resizeTimer = setTimeout(function () {
				updateLayout();
			}, 150);
		});
	});
}

/*
=====================
LARGE SLIDER
=====================
*/

function initLargeSliderSwipers() {
	const sections = document.querySelectorAll('.larger-slider-section');

	if (!sections.length || typeof Swiper === 'undefined') {
		return;
	}

	sections.forEach(function (section) {
		const swiperEl = section.querySelector('.large-slider');

		if (!swiperEl) {
			return;
		}

		const slides = swiperEl.querySelectorAll('.swiper-slide');
		const slideCount = slides.length;

		if (!slideCount) {
			return;
		}

		if (slideCount <= 1) {
			section.classList.add('is-single-slide');
			return;
		}

		const mobilePagination = section.querySelector('.large-slider-pagination-mobile');

		const swiperInstance = new Swiper(swiperEl, {
			loop: true,
			spaceBetween: 20,
			slidesPerView: 1,
			speed: 500,
			watchOverflow: true,
			observer: true,
			observeParents: true,

			navigation: {
				nextEl: section.querySelector('.large-slider-next.large-slider-arrow-desktop'),
				prevEl: section.querySelector('.large-slider-prev.large-slider-arrow-desktop'),
			},

			pagination: {
				el: section.querySelector('.large-slider-pagination'),
				clickable: true,
			},
		});

		function renderMobilePagination() {
			if (!mobilePagination) {
				return;
			}

			mobilePagination.innerHTML = '';

			for (let i = 0; i < slideCount; i++) {
				const bullet = document.createElement('button');

				bullet.type = 'button';
				bullet.className = 'swiper-pagination-bullet';
				bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));

				if (i === swiperInstance.realIndex) {
					bullet.classList.add('swiper-pagination-bullet-active');
				}

				bullet.addEventListener('click', function () {
					swiperInstance.slideToLoop(i);
				});

				mobilePagination.appendChild(bullet);
			}
		}

		const mobileNextButton = section.querySelector('.large-slider-next.large-slider-arrow-mobile');
		const mobilePrevButton = section.querySelector('.large-slider-prev.large-slider-arrow-mobile');

		if (mobileNextButton) {
			mobileNextButton.addEventListener('click', function () {
				swiperInstance.slideNext();
			});
		}

		if (mobilePrevButton) {
			mobilePrevButton.addEventListener('click', function () {
				swiperInstance.slidePrev();
			});
		}

		renderMobilePagination();

		swiperInstance.on('slideChange', function () {
			renderMobilePagination();
		});

		swiperInstance.on('afterInit', function () {
			renderMobilePagination();
		});

		window.addEventListener('resize', function () {
			swiperInstance.update();
			renderMobilePagination();
		});
	});
}

/*
=====================
FEATURED LOCATIONS
=====================
*/

function initFeaturedLocationsSwipers() {
	const swipers = document.querySelectorAll('.js-featured-locations-swiper');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		const section = swiperEl.closest('.featured-locations');
		const slides = swiperEl.querySelectorAll('.swiper-slide');

		if (!section || slides.length <= 1) {
			return;
		}

		let swiperInstance = null;
		const breakpoint = window.matchMedia('(max-width: 1120px)');

		function enableSwiper() {
			if (swiperInstance) {
				return;
			}

			swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 1.15,
				spaceBetween: 20,
				speed: 500,
				watchOverflow: true,
				grabCursor: true,

				pagination: {
					el: section.querySelector('.featured-locations-pagination'),
					clickable: true,
				},

				navigation: {
					nextEl: section.querySelector('.featured-locations-next'),
					prevEl: section.querySelector('.featured-locations-prev'),
				},

				breakpoints: {
					700: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				},
			});
		}

		function disableSwiper() {
			if (!swiperInstance) {
				return;
			}

			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}

		function handleBreakpoint() {
			if (breakpoint.matches) {
				enableSwiper();
			} else {
				disableSwiper();
			}
		}

		handleBreakpoint();

		if (breakpoint.addEventListener) {
			breakpoint.addEventListener('change', handleBreakpoint);
		} else {
			breakpoint.addListener(handleBreakpoint);
		}
	});
}

/*
=====================
TREATMENT SERVICES
=====================
*/

function initTreatmentServicesSwipers() {
	const swipers = document.querySelectorAll('.treatment-services-swiper');

	if (!swipers.length || typeof Swiper === 'undefined') {
		return;
	}

	swipers.forEach(function (swiperEl) {
		const wrap = swiperEl.closest('.treatment-services-slider-wrap');

		if (!wrap) {
			return;
		}

		const postCount = parseInt(swiperEl.dataset.postCount || '1', 10);

		const desktopSlides = Math.min(postCount, 5);
		const smallDesktopSlides = Math.min(postCount, 4);
		const tabletSlides = Math.min(postCount, 3);
		const smallTabletSlides = Math.min(postCount, 3);

		new Swiper(swiperEl, {
			slidesPerView: 'auto',
			spaceBetween: 10,
			loop: false,
			watchOverflow: true,
			grabCursor: true,

			navigation: {
				nextEl: wrap.querySelector('.treatment-services-swiper-next'),
				prevEl: wrap.querySelector('.treatment-services-swiper-prev'),
			},

			pagination: {
				el: wrap.querySelector('.treatment-services-swiper-pagination'),
				clickable: true,
			},

			breakpoints: {
				870: {
					slidesPerView: smallTabletSlides,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: tabletSlides,
					spaceBetween: 10,
				},
				1140: {
					slidesPerView: smallDesktopSlides,
					spaceBetween: 10,
				},
				1400: {
					slidesPerView: desktopSlides,
					spaceBetween: 10,
				},
			},
		});
	});
}

/*
=====================
MEGA MENU COLUMN ALIGNMENT

Each mega-menu category (e.g. "Our Partners", "Our Staff") renders as its
own independent grid, so its columns auto-size to that category's own
content only. This measures the natural column widths across every
category grid within a mega menu and applies the widest as an explicit
grid-template-columns to all of them, so the columns line up between
categories.

Column count must match the `.main-menu .level-1 .sub-menu` grid-cols
breakpoint in input.css (3 columns, dropping to 2 at max-width: 1550px).
=====================
*/

const MEGA_MENU_NARROW_QUERY = '(max-width: 1550px)';

function alignMegaMenuColumns() {
	const megaMenus = document.querySelectorAll('.main-menu .level-0.children-levels-2');

	if (!megaMenus.length) {
		return;
	}

	const columnCount = window.matchMedia(MEGA_MENU_NARROW_QUERY).matches ? 2 : 3;

	megaMenus.forEach(function (megaMenu) {
		const grids = megaMenu.querySelectorAll('.level-1 > .sub-wrap > .sub-menu');

		if (grids.length < 2) {
			return;
		}

		// Reset to natural auto-sizing before measuring.
		grids.forEach(function (grid) {
			grid.style.gridTemplateColumns = '';
		});

		const columnWidths = new Array(columnCount).fill(0);

		grids.forEach(function (grid) {
			Array.from(grid.children).forEach(function (item, index) {
				const column = index % columnCount;
				columnWidths[column] = Math.max(columnWidths[column], item.getBoundingClientRect().width);
			});
		});

		const template = columnWidths.map(function (width) {
			return Math.ceil(width) + 'px';
		}).join(' ');

		grids.forEach(function (grid) {
			grid.style.gridTemplateColumns = template;
		});
	});
}

let megaMenuResizeTimer = null;

window.addEventListener('resize', function () {
	clearTimeout(megaMenuResizeTimer);

	megaMenuResizeTimer = setTimeout(function () {
		alignMegaMenuColumns();
	}, 150);
});

if (document.fonts && document.fonts.ready) {
	document.fonts.ready.then(function () {
		alignMegaMenuColumns();
	});
}